import type { GlobalState } from '../types/globalState'

const matchUrl = (key: string, theme: GlobalState): string =>
  theme.linkFooter.find((value) => value?.linkType === key).link

export default matchUrl
